// src/utils/apiClient2.js
import axios from 'axios';
import { encryptAES, decryptAES } from './cryptoUtils';
import { getApgJWT } from './getApgJWT'

// Create a custom axios instance
const apiClient2 = axios.create({
  baseURL: '', 
  // If you need withCredentials for cookies, set it here:
  withCredentials: true,
});
// REQUEST INTERCEPTOR
apiClient2.interceptors.request.use(
  async (config) => {

    try{
      const token = await getApgJWT();
      console.log("token", token)
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (err) {
      console.error('Error fetching apg jwt token:', err);
    }

    if (config.method === 'post') {
      // Convert the data to JSON string
      const plainDataString = JSON.stringify(config.data);
      // Encrypt
      const encryptedPayload = encryptAES(plainDataString);
      // Replace the payload
      config.data = { encryptedRequest: encryptedPayload };
    }
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// RESPONSE INTERCEPTOR
apiClient2.interceptors.response.use(
  (response) => {
    // If there's an 'encryptedResponse' field, decrypt it
    if (response.data && response.data.encryptedResponse && response.data.token) {
      try {
        const decryptedString = decryptAES(response.data.encryptedResponse);
        const tokenLdap = response.data.token;
        
        console.log('Decrypted response:', decryptedString)
        // parse to JS object
        const plainObject = JSON.parse(decryptedString);
        console.log('plainObject response:', plainObject)
        // replace data in the response
        response.data = plainObject;

        console.log('Decrypted response for token:', tokenLdap)
        
        const expiresIn = 900 //900 is 15 mins
        localStorage.setItem('apg_jwt', tokenLdap);
        localStorage.setItem('apg_jwt_expiry', Date.now() + expiresIn * 1000);

      } catch (err) {
        console.error('Decryption error:', err);
        // optionally handle error or pass it through
      }
    }
    
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default apiClient2;